@if (isCustomerEmulationSessionInProgress$ | async) {
  <input
    formcontrolname="customer"
    type="text"
    disabled="true"
    placeholder="{{ customer?.name }}, {{ customer?.uid }}"
  />
  <button (click)="logoutCustomer()">End Session</button>
}
